import imgLeft from "../../assets/imgs/index/01.png";


export const style = {
    stack: {
        width: 'auto',
        height: '100vh',
    },
    leftArea: {
        backgroundImage:`url(${imgLeft})`,
        height: '100%',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        display:{ xs: 'none', sm: 'block'}
    },
    rightArea:{
        width: '100%',
        height: '100%',
        display:'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection:'column'
    },
    inputArea:{
        display:'flex',
        flexDirection:'column',
        gap: '25px',
        width: '70%',
    },
    titleArea:{
        display:'flex',
        width: '70%',
    },
    centerArea:{
        display:'flex',
        justifyContent: 'space-between',
        width: '70%',
        marginTop: '10px',
        marginBottom: '30px',
    },
    loginArea:{
        width: '70%',
    },
    newUserArea:{
        display:'flex',
        flexDirection:'row',
        justifyContent: 'center',
        alignItems: 'center',
        width: '70%',
        marginTop: '20px',
        marginBottom: '20px',
    },
    lineArea:{
        width: '70%',
    },
    socialArea:{
        width: '70%',
    },
    logo:{
        width: '350px',
    },
    logo1: {
        width: '100%',
        height: '100%',
        display:'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    logo2: {
        display:{ xs: 'block', sm: 'none'}
    },
    title: {
        fontSize: '30pt',
        color: "#5f615f",
        fontWeight: '700',
        marginBottom: '20px'
        
    },
    loginButton: {
        width: '100%',
    },
    facebookButton: {
        marginTop: '20px',
        width: '100%',
        backgroundColor: '#376db4',
    },
    googleButton: {
        marginTop: '20px',
        width: '100%',
        backgroundColor: '#c7d7e2',
        color: "#5f615f",
    },
    line:{

    }
}